import { render, staticRenderFns } from "./EMSpectrumViz.vue?vue&type=template&id=f3bd77c0&scoped=true"
import script from "./EMSpectrumViz.vue?vue&type=script&lang=js"
export * from "./EMSpectrumViz.vue?vue&type=script&lang=js"
import style0 from "./EMSpectrumViz.vue?vue&type=style&index=0&id=f3bd77c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bd77c0",
  null
  
)

export default component.exports